import { useState } from "react";
import useMainMenu from "../../api/useMainMenu";
import searchIcon from "../../images/icons/search.png";
import Loader from "../Loader/Loader";
import ProductMarkup from "../Markup/ProductMarkup";

export const Input = ({ type, path }) => {
  const [input, setInput] = useState("");

  const handleText = (e) => setInput(e.target.value);

  const { mainMenu, isLoading } = useMainMenu(type);

  const filter = mainMenu.filter((item) =>
    item.name.toLowerCase().includes(input.toLowerCase())
  );

  if (isLoading) {
    return <Loader />;
  } else
    return (
      <div className="search">
        <div className="search-box">
          <input
            type="text"
            placeholder="Пошук..."
            className="search-input"
            value={input}
            onChange={handleText}
          />
          <span className="search-btn">
            <img src={searchIcon} alt="search" />
          </span>
        </div>

        {input.length ? (
          <div className="search-list">
            <ProductMarkup path={path} filter={filter} />
          </div>
        ) : null}
      </div>
    );
};
